import React from 'react';
const access = 'Derecho de acceso';
const rectification = 'Derecho de rectificación';
const cancellation = 'Derecho de cancelación';
const opposition = 'Derecho de oposición';

export const LAW_TYPE_OPTIONS = [
  {
    id: access,
    name: access,
  },
  {
    id: rectification,
    name: rectification,
  },
  {
    id: cancellation,
    name: cancellation,
  },
  {
    id: opposition,
    name: opposition,
  },
];

export const nameLawMapper = new Map([['motiveClient', LAW_TYPE_OPTIONS]]);

export const arcoInfoExercises = new Map([
  [
    access,
    {
      information:
        'Te permite conocer si tenemos información tuya, y en caso de tenerla, qué datos son, cómo los obtuvimos, cuál es la finalidad de su uso y si se han comunicado con otras empresas o personas.',
    },
  ],
  [
    rectification,
    {
      information:
        'Te permite solicitar la corrección o modificación de tus datos personales si son erróneos, inexactos, equívocos o incompletos. Si tu solicitud hace referencia a un cambio legal de nombre o apellido, te pedimos adjuntar el documento que acredite esa situación.',
    },
  ],
  [
    cancellation,
    {
      information: (
        <div>
          Te permite solicitar la eliminación de tus datos cuando:
          <ul>
            <li>
              No sean necesarios para la finalidad para la cual fueron
              recolectados.
            </li>
            <li>Carezcan de fundamento legal.</li>
          </ul>
        </div>
      ),
    },
  ],
  [
    opposition,
    {
      information:
        'Te permite oponerte a que usemos tus datos para efectos de publicidad, estudios de mercado o encuestas de opinión.',
    },
  ],
]);
